<template>
  <div :class="'ali-modal'+(search?' with-search':'')" >
    <div class="header">
      {{ title }}
      <br v-if="search"/>
      <input ref='focusMe' type="text" v-if="search" @keyup="searchIt" :value="searchValue"  @input="e => searchValue = e.target.value" class="form-control" placeholder="جستجو ...">
    </div>
    <div class="modal-content">
      <!-- current selected items -->
      <div class="select-item active"
           @click="callSetSelected($event)" v-for="item in getSelectedItems()" :key="item[itemId]"
           :data-value="item[itemId]">
        {{ item[itemTitle] }}
      </div>


      <div class="select-item"
           @click="callSetSelected($event)" v-for="item in filteredItems" :key="item[itemId]"
           :data-value="item[itemId]">
        {{ item[itemTitle] }}
      </div>
    </div>
    <div class="footer">
      <button class="btn btn-info" @click="closeModal">بستن</button>
    </div>
  </div>
</template>

<script>
import {defineComponent} from 'vue';
import jwtInterceptor from "@/shared/jwtInterceptor";

export default defineComponent({
  name: 'Modal',
  mounted()
  {
    if (this.search)
    {
      const self = this;
      setTimeout(function (){
        self.$refs.focusMe.focus()
      },550)
    }
  },
  data: () =>
  {
    return {
      searchValue: '',
      items: []
    }
  },
  methods: {
    callSetSelected(event)
    {
      const self = this;
      this.setSelected(event, self.items)
    },
    async doSearch(query)
    {
      if (this.route)
      {
        let ch = '?';
        if (this.route.indexOf('?') >= 0)
          ch = '&';
        if (query.length > 1)
        {
          const url = process.env.VUE_APP_API_URL + process.env.VUE_APP_API_PATH + this.route + ch + 'q=' + query;
          const result = await jwtInterceptor.get(url);
          if (result && result.data && result.data.ok && result.data.items)
          {
            this.items = result.data.items;
            this.$emit('myEvent')
          }
        }
      }
    },
    searchIt:function ()
    {
      this.doSearch(this.searchValue)
    }
  },
  // watch: {
  //   searchValue: function ()
  //   {
  //     this.doSearch(this.searchValue)
  //   }
  // },
  computed: {
    filteredItems()
    {
      const self = this;
      return this.items.filter(item =>
      {
        return !this.searchInSelectedItems(item[self.itemId])
      })
    }
  },
  props: [
    'title',
    'itemTitle',
    'itemId',
    'name',
    'multiple',
    'setSelected',
    'search',
    'closeModal',
    'searchInSelectedItems',
    'getSelectedItems',
    'route'
  ],
  components: {}
});
</script>

<style scoped>
.ali-modal {
  height: 100%;
  border-radius: 5px;
}

.modal-content {
  border-radius: 5px;
  height: calc(100% - 95px);
  margin: 5px 0;
  overflow-y: auto;
  padding: 15px;
}

.with-search .modal-content {
  height: calc(100% - 135px);
}

.header {
  height: 40px;
  padding: 5px 15px;
  background: #f5f5f5;
}

.footer {
  height: 45px;
  padding: 5px 15px;
  background: #fff;
  text-align: left;
}

.footer .btn {
  margin-top: -5px;
}

.with-search .header {
  height: 80px;
}

.header {
  box-shadow: 0px 0 5px 5px rgba(0, 0, 0, 0.2);
  text-align: center;
  font-weight: bold;
}

.select-item {
  box-shadow: 0 0 5px 0px rgba(0, 0, 0, 0.2);
  border-radius: 4px;
  margin-bottom: 6px;
  padding: 5px 10px;
  background: #ffffff;
  color: black !important;
}

.select-item.active {
  background: #d9d9d9;
}
</style>
